import { FESTIVE_LOTTIE_ASSETS, LOTTIE_ASSETS, SOUND_ASSETS } from "@swiggy-private/core-ui";
import { getCloudinaryRawUrl } from "@swiggy-private/js-utils";

export enum TICK_STATES {
    LOADING,
    SUCCESS,
}

export enum TICK_ACCENT {
    GREEN = "GREEN",
    BRICK = "BRICK",
    VIOLET = "VIOLET",
    MUSTARD = "MUSTARD",
    LIGHT_GREEN = "LIGHT_GREEN",
}

export const DEFAULT_ACCESSIBILITY_TEXTS = {
    [TICK_STATES.SUCCESS]: "Order Placed Successfully",
    [TICK_STATES.LOADING]: "Processing",
};

export const SCOOTER_ICON = {
    imageId: "4_0_Assets/prioritydelivery",
    width: 85,
    height: 37,
};

export const MILLISECONDS_IN_SECOND = 1000;

export const SUB_TEXT_TIMEOUT = 2 * MILLISECONDS_IN_SECOND; // in milliseconds
export const BOLT_TIMEOUT = 3.5 * MILLISECONDS_IN_SECOND; // in milliseconds
export const GIFTING_CART_TIMEOUT = 4.5 * MILLISECONDS_IN_SECOND; // in milliseconds
export const AFFORDABLE_CART_M2_TIMEOUT = 3.5 * MILLISECONDS_IN_SECOND; // in milliseconds
export const MRO_TIMEOUT = 10 * MILLISECONDS_IN_SECOND; // in milliseconds
export const blackBenefitTextTimeout = (textlength: number) => (2 + textlength * 1) * MILLISECONDS_IN_SECOND; // in milliseconds
export const TRANSITION_LOTTIE_DELAY = 3.5 * MILLISECONDS_IN_SECOND; // in milliseconds

export const TRANSITION_ANIMATION_SEGMENT = [0, 40];
export const TRANSITION_LOADING_SEGMENT = [40, 81];
export const TRANSITION_ANIMATION_SEGMENT_TOING_QUICK = [0, 25];
export const TRANSITION_LOADING_SEGMENT_TOING_QUICK = [25, 39];
export const TRANSITION_SUCCESS_SEGMENT_START = 131;
export const TRANSITION_SUCCESS_SEGMENT_START_AFFORDABLE = 70;
export const TRANSITION_SUCCESS_SEGMENT_START_TOING = 130.5;
export const TRANSITION_SUCCESS_SEGMENT_START_TOING_QUICK = 60.5;

export const TRANSITION_LOTTIE_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID);
export const TOING_TRANSITION_LOTTIE_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TOING_TRANSITION_LOTTIE_FILE_ID);
export const TOING_QUICK_TRACK_LOTTIE_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TOING_QUICK_TRACK_LOTTIE_FILE_ID);
export const TRANSITION_LOTTIE_BLACK_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_BLACK);
export const TRANSITION_LOTTIE_BLACK_OTP_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_BLACK_OTP);
export const TRANSITION_LOTTIE_POP_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_POP);
export const FESTIVE_TRANSITION_LOTTIE_URL = getCloudinaryRawUrl(
    FESTIVE_LOTTIE_ASSETS.FESTIVE_TRANSITION_LOTTIE_FILE_ID,
);
export const TRANSITION_LOTTIE_BOLT_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_BOLT);
export const TRANSITION_LOTTIE_BOLT_OTP_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_BOLT_OTP);
export const TRANSITION_LOTTIE_AFFORDABLE_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_AFFORDABLE);
export const TRANSITION_LOTTIE_TRING_SOUND_URL = getCloudinaryRawUrl(SOUND_ASSETS.TRING_SOUND);
export const TRANSITION_LOTTIE_SPEEDY_SOUND_URL = getCloudinaryRawUrl(SOUND_ASSETS.SPEEDY_SOUND);
export const TRANSITION_LOTTIE_TOING_SOUND_URL = getCloudinaryRawUrl(SOUND_ASSETS.TOING_SOUND);
export const TRANSITION_LOTTIE_GIFTING_ORDER_PLACED_URL = getCloudinaryRawUrl(
    LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_GIFTING_ORDER_PLACED,
);

export const TRANSITION_LOTTIE_MRO_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_MRO);
export const TRANSITION_MRO_STRIP_LOTTIE_URL = getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_MRO_STRIP);

// Placeholder text baked into the MRO transition lottie's text layers.
export const MRO_ORDER_COUNT_PLACEHOLDER = "OrderCount";

export const TRANSITION_LOTTIE_TIMEOUT = 5 * MILLISECONDS_IN_SECOND; // in milliseconds

export const TRANSITION_LOTTIE_ASSET_PATH = "portal/m/cw_transition_screen_v2/images";

export const PERCENTAGE_ICON_WIDTH = 24;
export const PERCENTAGE_ICON_HEIGHT = 24;

export const REWARD_UNLOCKED_WITH_SAVINGS = "& reward unlocked!";

export const REWARD_UNLOCKED_WITHOUT_SAVINGS = "[[Reward Unlocked!]]";

export const SAVINGS_IMAGE_IDS = {
    FREE_DELIVERY: "transition_screen/Free-Delivery-final.png",
    GENERIC: "transition_screen/generic-final.png",
    TOING: "portal/static-assets/images/toing.png",
};

export const BLACK_OTP_LOTTIE_ASSET_IDS = {
    SHIMMER: "golden_shimmer.png",
    OTP_STAMP: "one_blck_otg_stamp.png",
    STAR: "bright_star.png",
};

export enum MARKER_NAMES {
    TRING_SOUND = "tringSound",
    SPEEDY_SOUND = "speedy_sound",
    TOING_SOUND = "tick_sound",
}

export const TOING_QUICK_SLA_OPTION = "QUICK";

export const TOING_QUICK_LOTTIE_LAYER_NAMES = {
    SAVINGS_CALLOUT: "savingscallout",
    TIME_SAVED_CALLOUT: "timesavedcallout",
} as const;

export enum ON_SUCCESS_CALLBACK_TYPE {
    INVALID = "INVALID",
    MRO = "MRO",
}
